import gql from 'graphql-tag';

export const GET_INDIVIDUAL_SERVICE_REQUEST = gql`
	query GetServiceRequestMain($id: String!) {
		serviceRequest(id: $id) {
			id
			status
			editor {
				id
			}
			completedFiles {
				id
			}
			requestedFiles {
				id
				status
				filename
				webUrl
				width
				height
			}
			service {
				id
				property {
					id
				}
			}
		}
	}
`;

export const GET_INDIVIDUAL_SERVICE_REQUEST_PROPERTY = gql`
	query serviceRequestProperty($id: String!) {
		property(id: $id) {
			id
			address
			unitNumber
			alias
		}
	}
`;
